import React, {useState} from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Legend,
    ResponsiveContainer,
    Label,
    LabelList,
    Tooltip
} from 'recharts';
import styles from './verticalBarGraph.module.css';

const CustomLegend = (props) => {
    const { payload } = props;
    return (
        <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
            {payload.map((entry, index) => {
                const { value, color } = entry;
                return (
                    <span
                        key={`item-${index}`}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '0 10px',
                        }}
                    >
                        <span
                            style={{
                                backgroundColor: color,
                                width: '6px',
                                height: '12px',
                                display: 'inline-block',
                                borderRadius: '2px',
                            }}
                        />
                        <span style={{ color: '#4D4D4F' }}>{value}</span>
                    </span>
                );
            })}
        </div>
    );
};


const CustomOutsideLabel = (props) => {
    const { x, y, width, value, height } = props;

    // Skip label if value is 0 or null
    if (!value) return null;

    return (
        <text
            x={x + width + 5} // Position a bit to the right of the bar
            y={y + height / 2}
            dy={4} // Vertically center
            fill="#000"
            fontSize={12}
        >
            {value.toFixed(1)}
        </text>
    );
};
const StackBarGraph = ({ data }) => {
    const recordsCount = data?.length || 0;
    const barHeight = 15;
    const chartHeight = recordsCount * barHeight + 200;
    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };
    
    const [activeLine, setActiveLine] = useState(null);
    const [tooltipTimeout, setTooltipTimeout] = useState(null);
    const handleMouseEnter = (lineKey) => {
        // Clear any existing timeout
        if (tooltipTimeout) {
            clearTimeout(tooltipTimeout);
        }

        // Set new timeout to prevent flickering
        setTooltipTimeout(setTimeout(() => {
            setActiveLine(lineKey);
        }, 100));
    };
    const handleMouseLeave = () => {
        if (tooltipTimeout) {
            clearTimeout(tooltipTimeout);
        }
        setActiveLine(null);
    };
    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length > 0 && activeLine === 'Required capacity (shifts)') {
            return (
                <div className={styles.customTooltip}>
                    {payload.length > 0 && (
                        <>
                            {payload[0].payload.CBUDescription && (
                                <p className={styles.tooltipItem}>
                                    <span style={{ fontWeight: 600 }}>CBU Description:</span> {payload[0].payload.CBUDescription}
                                </p>
                            )}
                        </>
                    )}
                    {payload.map((item, index) => (
                        <p key={index} className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>{item.name}</span>: {item.value.toFixed(1)}
                            {item.payload["Unit of Measure"] && ` ${item.payload["Unit of Measure"]}`}
                        </p>
                    ))}
                    {payload[0].payload.Agile_Plan && (
                        <p className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>Agile Plan</span>: {payload[0].payload.Agile_Plan}
                        </p>
                    )}
                    {payload[0].payload.ProjectedLoss && (
                        <p className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>Projected Loss</span>: {payload[0].payload.ProjectedLoss}
                        </p>
                    )}
                </div>
            );
        }
        return null;
    };
    return (
        <ResponsiveContainer width="100%" height={chartHeight}>
            <BarChart
                data={data}
                layout="vertical"
                margin={{
                    top: 10,
                    right: 15,
                    left: 10,
                    bottom: 10,
                }}
            >
                <XAxis
                    type="number"
                    domain={[0, 'auto']}
                    tickLine={false}
                    className={styles.BarLabelCBU}
                    axisLine={{ strokeDasharray: "3 3", stroke: "#ccc" }}
                >
                    <Label value="Shifts" position="insideBottom" offset={-5} className={styles.axisLabel} />
                </XAxis>
                <YAxis dataKey="name" type="category" axisLine={{ strokeDasharray: "3 3", stroke: "#ccc" }} />
                <Tooltip
                    content={<CustomTooltip />}
                    wrapperStyle={{
                        fontSize: '12px',
                        padding: '6px',
                    }}
                />
                <Legend
                    verticalAlign="bottom"
                    align="left"
                    wrapperStyle={legendStyle}
                    content={<CustomLegend />}
                />
                <Bar
                    dataKey="Required capacity (shifts)"
                    name="Required capacity (shifts)"
                    fill="#00B190"
                    barSize={20}
                    radius={[0, 4, 4, 0]}
                    stackId="a"
                    activeDot={{
                        r: 6
                    }}
                    onMouseOver={() => handleMouseEnter('Required capacity (shifts)')}
                    onMouseLeave={handleMouseLeave}
                >
                    <LabelList
                        dataKey="Required capacity (shifts)"
                        // position="inside"
                        content={<CustomOutsideLabel />}
                        className={styles.labelList}
                        formatter={(value) => value !== 0 ? value?.toFixed(1) : ''}
                    />
                </Bar>
                <Bar
                    dataKey="Available capacity (shifts)"
                    name="Available capacity (shifts)"
                    fill="#FFC000"
                    barSize={20}
                    radius={[0, 4, 4, 0]}
                    stackId="b"
                    activeDot={{
                        r: 6
                    }}
                    onMouseOver={() => handleMouseEnter('Available capacity (shifts)')}
                    onMouseLeave={handleMouseLeave}
                >
                    <LabelList
                        dataKey="Available capacity (shifts)"
                        // position="insideRight"
                        content={<CustomOutsideLabel />}
                        className={styles.labelList}
                        formatter={(value) => value !== 0 ? value?.toFixed(1) : ''}
                    />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default StackBarGraph;